import saas from '@/utils/saas'
import request from '@/utils/request'
const url = saas.Constant.GATEWAY_URL
/**
 * 分页初始化属性
 */
const TOTAL = 0
const PAGE = 1
const SIZE = 10

/**
 * 成功响应码
 */
const RESP_SUCCESS = '0000'

/**
 * 对象 NULL值 设置
 * @param obj
 * @returns {*}
 */
export function setNull(obj) {
  for (const i in obj) {
    if (obj[i] === '' || obj[i] === undefined || obj[i] === 'undefined') {
      obj[i] = null
    }
  }
  return obj
}

// 日期加天数
export function getNewDay(dateTempValue, days) {
  const dateTemp = dateTempValue.split('-')
  var nDate = new Date(dateTemp[1] + '-' + dateTemp[2] + '-' + dateTemp[0]) // 转换为MM-DD-YYYY格式
  var millSeconds = Math.abs(nDate) + (days * 24 * 60 * 60 * 1000)
  var rDate = new Date(millSeconds)
  var year = rDate.getFullYear()
  var month = rDate.getMonth() + 1
  if (month < 10) month = '0' + month
  var date = rDate.getDate()
  if (date < 10) date = '0' + date
  return (year + '-' + month + '-' + date)
}
/** *
 * 封装请求参数、请求路径
 * @param service, api, data
 * @param api
 * @param data
 * @param xUserAction
 * @returns { request }
 */
export function createRequest(service, api, data, xUserAction) {
  data = saas.data(service, api, data)
  if (xUserAction) {
    data.xUserAction = xUserAction
  }
  return request({
    url: url + '/' + service + '/api/' + api,
    method: 'post',
    headers: saas.header(data),
    data
  })
}
/** *
 * 封装下载的请求参数、请求路径
 * @param service, api, data
 * @returns {request data}
 */
export function createDownRequest(service, api, data) {
  data = saas.data(service, api, data)
  return request({
    url: url + '/' + service + '/api/' + api,
    method: 'post',
    headers: saas.header(data),
    data,
    responseType: 'blob'
  })
}
// 创建下载 接口：zhangzhiwu
export function Createfile(data) {
  return createRequest('report-api', 'EXPORT_JOB_CREATE', data, '下载')
}
// 创建下载 接口：zhangzhiwu
export function getfile(data) {
  return createRequest('report-api', 'EXPORT_JOB_QUERY', data, '查询导出列表')
}
export default {
  name: 'Common',
  TOTAL, PAGE, SIZE, RESP_SUCCESS,
  setNull,
  getNewDay,
  createRequest,
  createDownRequest,
  Createfile,
  getfile
}
